import { ZoomBlurFilter as PixiZoomBlur } from 'pixi-filters'
import { useProjectStore } from '@/store/project-store'
import AudioIntensityAnalyzer from '@/audio/AudioIntensityAnalyzer'
import { SeratoFilter, EffectState } from '@/pixi/filters/types'
import useAudioEngine from '@/composables/UseAudioEngine'
const { audioBackgroundIntensity } = useAudioEngine()

export class ZoomBlurFilter extends PixiZoomBlur implements SeratoFilter {
  protected projectStore = useProjectStore()
  
  constructor (private effectState: EffectState) {
    super()
  }

  public updateUniforms (): void {
    const canvasDimensions = this.projectStore.resolution
    const audioIntensity = this.effectState.audioReactivityEnabled
      ? AudioIntensityAnalyzer.getAudioIntensity(this.uniforms.audioFrequencyData, audioBackgroundIntensity.value) : 1

    this.center = [canvasDimensions.width / 2, canvasDimensions.height / 2]
    this.strength = 0.03 + (this.effectState.intensity / 3) * audioIntensity
    this.radius = Math.sqrt(Math.pow(canvasDimensions.width, 2) + Math.pow(canvasDimensions.height, 2)) / 2
    this.innerRadius = 0
  }
}
